import { Home, Settings, Users, Menu, X, NotebookText, LayoutDashboard, Rocket, LogOut ,HandCoins,Bot,Codesandbox,Wallet} from "lucide-react";

export const sideBarLinks = [
    {
      label: 'Home',
      to: '/',
      icon: <Home size={24} />,
      tag:'home'
    },
    {
      label: 'Dashboard',
      to: '/dashboard',
      icon: <LayoutDashboard size={24} />,
      tag:'/dashboard'
    },
    {
      label: 'Launchpad',
      to: '/dashboard/ico',
      icon: <Rocket size={24} />,
      tag:'/dashboard/ico'
    },
    {
      label: 'Referral Program',
      to: '/dashboard/referrals',
      icon: <Users size={24} />,
      tag:'referral'
    },
    {
      label: 'Claim Tokens',
      to: '/dashboard/claim',
      icon: <HandCoins size={24} />,
      tag:'/dashboard/claim'
    },
    {
      label: 'PumpFun Bot',
      to: '/dashboard/pumpbot',
      icon: <Bot size={24} />,
      tag:'/dashboard/pumpbot'
    },
    {
      label: 'Rayfast Bot',
      to: '/dashboard/rayfast',
      icon: <Codesandbox size={24} />,
      tag:'/dashboard/raydium'
    },
    // {
    //   label: 'Billing',
    //   to: '/dashboard/billing',
    //   icon: <Wallet size={24} />,
    //   tag:'/dashboard/billing'
    // },
    {
      label: 'How to Buy',
      to: '/dashboard/documents',
      // to: 'https://docs.phoenixbot.io/',
      icon: <NotebookText size={24} />,
      tag:'Documents',
      // target:'_blank'
    },
    // {
    //   label: 'Settings',
    //   to: '',
    //   icon: <Settings size={24} />,
    //   tag:'Settings'
    // },
  ]